import { AUTH, LOGOUT, UPDATE_USER_COURSES_TAKEN } from '../constants/userConstants'


const UserReducer = (state= {authData: null}, action)=> {
    var user = JSON.parse(localStorage.getItem('profile'));
    switch (action.type)
    {
       // Store which courses / sections we have looked at.
        case UPDATE_USER_COURSES_TAKEN:
            user.result.coursesTaken= action.payload;
            localStorage.setItem('profile', JSON.stringify({...user}))
            return {...state, authData:user}
        case AUTH:
            // Data is in action.data. This stores it all locally
            localStorage.setItem('profile', JSON.stringify({...action?.data}))
            // Adds the auth data to the state and returns
            return {...state, authData: action?.data}; 
        case LOGOUT:
            // Clears the auth data from the state
            localStorage.clear() ; 
            return {...state, authData: null }; 
        default:
            return state ; 
    }
} ; 

export default UserReducer ; 
